/**
 * Generates react select options from given array of object.
 *
 * @param array
 * @param model Object keys from which react select's value and label is to fetched.
 * @returns */

export type FlatSelectOptionType = { value: string | number; label: string | number };

export type SkillGroupOptionType = {
  label: string;
  options: Array<{ label: string; value: string | number; id: string | number; category?: { name: string } }>;
};

export type EndLevelSkillType = { category: { name: string }; id: string | number; name: string };

export const generateReactSelectOptionsFromObject = (
  array: Array<Record<string, string | number>>,
  model: { value: string; label: string } = { value: 'id', label: 'name' }
): Array<FlatSelectOptionType> => array.map((item) => ({ value: item[model.value], label: item[model.label] }));

/**
 * Generates react select options for given array of string.
 *
 * @param array
 * @returns */
export const generateReactSelectOptions = (
  array: Array<string | number>
): Array<{ value: string | number; label: string | number }> => array.map((value) => ({ value, label: value }));

/**
 * Generates react select group options for given array.
 *
 * @param array
 * @returns */
export const generateReactSelectSkillGroupOptions = (
  array: Array<EndLevelSkillType>,
  addCategory = false
): Array<SkillGroupOptionType> => {
  const groupOptions = array.reduce((acc, item) => {
    const { category, id, name } = item;

    const label = category.name;

    const showCategory = { ...(addCategory ? { category } : {}) };

    if (!acc[label]) {
      acc[label] = { label, options: [] };
    }

    acc[label].options.push({ label: name, value: id, id, ...showCategory });

    return acc;
  }, {});

  return Object.values(groupOptions);
};
